import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=23c5984f"
import script from "./home.ts?vue&type=script&lang=ts&external"
export * from "./home.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports